import api from './api';

const rapprochementAPI = {
  getAll: (params) => api.get('/rapprochements', { params }),
  getById: (id) => api.get(`/rapprochements/${id}`),
  create: (data) => api.post('/rapprochements', data),
};

export default rapprochementAPI;
